import axios from 'axios'
import { registerInterceptors } from '@/lib/api/interceptors'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: { Accept: 'application/json' },
})

registerInterceptors(api)
